import { useEffect, useRef } from 'react';

/** Lets async work that outlives the component skip its state updates. */
export const useMountedRef = () => {
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  return mountedRef;
};
